export default {
  'profile.address1': 'Address 1',
  'profile.address2': 'Address 2',
  'profile.city': 'City',
  'profile.faxNumber': 'Fax Number',
  'profile.postalCode': 'Zip Code',
  'profile.required': 'Required information cannot be blank',
  'profile.setup': 'Setup Security Profile',
  'profile.state': 'State',
  'profile.userCode': 'User Name',
  'profile.userInformation': 'User Contact Information',
  'profile.userTab': 'User Contact'
};
